"use strict";var t=require("react"),e=require("../ToastContext.js");exports.useToast=()=>t.useContext(e.ToastContext);
